import React from 'react';
import { useTranslation } from 'react-i18next';
import { images } from '../../../constants';
import './AboutUs.css';

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <div className="app__aboutus app__bg flex__center section__padding" id="about">
      <div className="app__aboutus-content flex__center">
        {/* About Section */}
        <div className="app__aboutus-content_about">
          <h1 className="headtext__cormorant">{t('about_section.about_title')}</h1>
          <img src={images.spoon} alt="about_spoon" className="spoon__img" />
          <p className="p__opensans">{t('about_section.about_content_1')}</p>
          <p className="p__opensans">{t('about_section.about_content_2')}</p>
        </div>

        {/* Knife Section (hidden on mobile) */}
        <div className="app__aboutus-content_knife flex__center">
          <img src={images.knife} alt="about_knife" />
        </div>

        {/* History Section */}
        <div className="app__aboutus-content_history">
          <h1 className="headtext__cormorant">{t('about_section.story_title')}</h1>
          <img src={images.spoon} alt="about_spoon" className="spoon__img" />
          <p className="p__opensans">{t('about_section.story_content_1')}</p>
          <p className="p__opensans">{t('about_section.story_content_2')}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
